<template>
  <ul :id="id"
      class="v-tabs nav nav-pills"
      role="tablist"
      :class="{'grow': grow}">
    <slot></slot>
  </ul>
</template>

<script>
export default {
  name: 'VTabs',
  data() {
    return {}
  },
  props: {
    id: {
      type: String,
      required: true,
    },
    grow: Boolean,
  },
  computed: {},
  methods: {
    addActive() {
      const tabs = this.$slots.default;
      let isAnyoneActive = false;

      if (!!tabs) {
        console.log(tabs)
        isAnyoneActive = tabs.some(tab => tab.componentInstance.$props.active);

        if (!isAnyoneActive) {
          tabs[0].elm.firstChild.classList.add('active');
          tabs[0].elm.firstChild.ariaSelected = "true";
        }
      }
    }
  },
  mounted() {
    this.addActive();
  }
};
</script>

<style lang="scss">
@import "VTabs";
</style>
